import styled, { css, CSSProperties } from 'styled-components';

import { sizeStyles, StyledSizeProps } from '../../styles';
import checkMark from '../../svgs/checkMark.svg';
import checkMarkDisabled from '../../svgs/checkMarkDisabled.svg';
import borderRadius from '../../theme/constants/borderRadius';
import colors from '../../theme/constants/colors';

import {
  CheckboxClassNames,
  CheckboxGapKey,
  CheckboxSpacingKey,
} from './constants';

const transitionDuration = 200;

type ContainerProps = {
  $isDisabled: boolean | undefined;
  $whiteSpace: CSSProperties['whiteSpace'];
} & StyledSizeProps;

export const CheckboxContainer = styled.label<ContainerProps>`
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  display: flex;
  gap: ${({ theme }) => theme.core.spacing[CheckboxGapKey]};
  align-items: center;
  padding: ${({ theme }) => theme.core.spacing[CheckboxSpacingKey]};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  transition: all ${transitionDuration}ms ease-in-out;
  user-select: none;
  width: max-content;
  max-width: 100%;
  overflow: hidden;

  white-space: ${({ $whiteSpace = 'nowrap' }) => $whiteSpace};

  &:hover {
    .${CheckboxClassNames.Main} {
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        z-index: -1;
        width: 40px;
        height: 40px;
        border-radius: ${borderRadius.full};

        background-color: ${({ $isDisabled }) => !$isDisabled && colors.sand};
      }
    }
  }

  ${sizeStyles}
`;

const errorStyles = css`
  border-color: ${colors.error};
  outline: 1px solid ${colors.error};
`;

export const InputElement = styled.input<{ $hasError: boolean | undefined }>`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0;
  border: 1px solid ${colors.pigeon};
  border-radius: 4px;
  cursor: pointer;
  transition: all ${transitionDuration}ms ease-in-out;
  appearance: none;
  outline-offset: 0;
  outline: none;

  ${({ $hasError }) => ($hasError ? errorStyles : '')}

  &:focus-visible {
    box-shadow: 0 0 0 4px ${colors.sand};
  }

  &:disabled {
    border-color: ${colors.mouse};
    cursor: not-allowed;
  }

  &:checked {
    background-color: ${colors.navy};
    background-image: url(${checkMark});
    border-color: transparent;

    &:focus-visible {
      box-shadow: 0 0 0 4px #9d9db4;
    }

    &:disabled {
      background-image: url(${checkMarkDisabled});
      background-color: #e5e6eb;
      border-color: transparent;
    }
  }
`;

export const Label = styled.span<{ $hasError: boolean | undefined }>`
  color: ${({ $hasError }) => ($hasError ? colors.error : colors.navy)};
  font-size: 14px;
  line-height: 1.25;
  text-overflow: ellipsis;
  overflow: hidden;
`;
